import { trackEvent } from "@/domains/metrics/segment";
import { TrackedEvent } from "@/domains/metrics/tracked-event";

const KEYBOARD_SHORTCUT_METRIC_DEBOUNCE_MS = 60_000;

const lastTrackedAtByShortcut = new Map<string, number>();

interface TrackKeyboardShortcutPressedArgs {
  shortcut: string;
  now?: number;
}

export const clearKeyboardShortcutMetricDebounceForTesting = () => {
  lastTrackedAtByShortcut.clear();
};

export const trackKeyboardShortcutPressed = ({
  shortcut,
  now = Date.now(),
}: TrackKeyboardShortcutPressedArgs) => {
  const lastTrackedAt = lastTrackedAtByShortcut.get(shortcut);
  if (lastTrackedAt !== undefined && now - lastTrackedAt < KEYBOARD_SHORTCUT_METRIC_DEBOUNCE_MS) {
    return;
  }

  lastTrackedAtByShortcut.set(shortcut, now);
  trackEvent(TrackedEvent.KeyboardShortcutPressed, { shortcut });
};
